var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalkingOnPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 755.916,
    height: 779.013,
    viewBox: "0 0 755.916 779.013",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-510.674 -142.449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.736,259.7h-6.555V219.34a20.566,20.566,0,0,0-20.566-20.566h-28.4V140.692h-4.555v58.081H325.934V259.7H287.783V843.93h214.1V336.852A77.15,77.15,0,0,0,424.736,259.7Z",
    transform: "translate(235.61 47.795)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.238,567.689h-5.654v-7.9a20.551,20.551,0,0,0-19.36-20.506V485.692h-4.555v53.526h-20.5v28.471H472.283V796.6H634V606.45A38.761,38.761,0,0,0,595.238,567.689Z",
    transform: "translate(261.227 95.697)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.5,424.506V410.784a20.549,20.549,0,0,0-19.36-20.506V336.692h-4.555v53.526h-20.5v34.165h-96.8v392.9h214.1V501.533A77.147,77.147,0,0,0,871.5,424.506Z",
    transform: "translate(297.049 75.01)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(1062.636 555.195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(1109.329 555.195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(1062.636 613.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(1109.329 613.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(1062.636 671.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(1109.329 671.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(1062.636 729.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(1109.329 729.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(1062.636 787.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(1109.329 787.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(1062.636 845.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(1109.329 845.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.246,
    height: 6.833,
    transform: "translate(584.321 353.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.246,
    height: 6.833,
    transform: "translate(584.321 395.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.246,
    height: 6.833,
    transform: "translate(584.321 437.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.246,
    height: 6.833,
    transform: "translate(584.321 480.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.246,
    height: 6.833,
    transform: "translate(584.321 522.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.246,
    height: 6.833,
    transform: "translate(584.321 564.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.246,
    height: 6.833,
    transform: "translate(584.321 606.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.246,
    height: 6.833,
    transform: "translate(584.321 648.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.246,
    height: 6.833,
    transform: "translate(584.321 690.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.246,
    height: 6.833,
    transform: "translate(584.321 732.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.246,
    height: 6.833,
    transform: "translate(584.321 774.994)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.246,
    height: 6.833,
    transform: "translate(584.321 817.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(753.44 694.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(800.132 694.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(846.825 694.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(754.009 752.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(800.702 752.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(847.395 752.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(754.579 810.297)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(801.271 810.297)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(847.964 810.297)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.471,
    height: 22.777,
    transform: "translate(593.432 259.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.189,705.182a6.133,6.133,0,0,0,4.818,3.264c.518.051.37.846-.145.8a6.873,6.873,0,0,1-5.338-3.6.418.418,0,0,1,.1-.563A.407.407,0,0,1,354.189,705.182Z",
    transform: "translate(244.729 126.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.695,734.2a20.882,20.882,0,0,0,14.691-3.986c.418-.311.878.354.456.664a21.719,21.719,0,0,1-15.291,4.119C804.033,734.937,804.18,734.142,804.695,734.2Z",
    transform: "translate(307.316 129.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.844,614.281a.443.443,0,0,0,.2-.356c-.059.052-.114.107-.178.158C712.862,614.151,712.86,614.213,712.844,614.281Z",
    transform: "translate(294.628 113.502)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.3,478.869l-5.078,2.6a.2.2,0,0,1-.186-.362l5.078-2.6a.2.2,0,0,1,.186.362Z",
    transform: "translate(281.451 94.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.163,
    cy: 0.163,
    rx: 0.163,
    ry: 0.163,
    transform: "translate(905.293 572.814)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.615,690.439c0,.945.556,1.714,1.246,1.717h753.417c.692,0,1.253-.769,1.253-1.717s-.561-1.717-1.253-1.717H256.868c-.69,0-1.251.761-1.253,1.707Z",
    transform: "translate(255.059 203.572)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.68,151.15c-19.5,39.55-7.39,47.82-5.46,48.84-4.13-1.92-57.81-27.14-50.75-33.54,4.59-4.17,8.52-22.31,10.83-35.31,1.37-7.76,2.17-13.69,2.17-13.69l56.33,10.33A265.57,265.57,0,0,0,516.68,151.15Z",
    transform: "translate(471.36 89.988)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.088,574.691l-8.762,18.986-16.065-1.46-10.222-33.591,16.064-8.762Z",
    transform: "translate(171.22 1435.657) rotate(-73)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.163,712.274s8.763-2.921,8.763,2.921-5.842,23.368-5.842,23.368,8.763,54.038-4.381,51.117-23.367-27.749-24.828-35.051-8.763-45.275-8.763-45.275-11.684-27.749-4.381-29.21,27.749-7.3,27.749-7.3S921.8,709.353,945.163,712.274Z",
    transform: "translate(4.793 1554.406) rotate(-73)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.088,574.691l-8.762,18.986-16.065-1.46-10.222-33.591,16.064-8.762Z",
    transform: "translate(80.278 217.195)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.163,712.274s8.763-2.921,8.763,2.921-5.842,23.368-5.842,23.368,8.763,54.038-4.381,51.117-23.367-27.749-24.828-35.051-8.763-45.275-8.763-45.275-11.684-27.749-4.381-29.21,27.749-7.3,27.749-7.3S921.8,709.353,945.163,712.274Z",
    transform: "translate(-81.94 92.76)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.3,175.28l-.34.45-1.16,1.55L567.55,193l-4.72-7.76-3-5s-44.35-26.6-25.28-52.24,47.25,32.5,47.25,32.5Z",
    transform: "translate(471.36 89.988)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.43,
    height: 2.06,
    rx: 0.21,
    transform: "matrix(0.893, -0.45, 0.45, 0.893, 992.326, 209.596)",
    fill: "#3a3768"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.48,
    height: 3.59,
    rx: 0.24,
    transform: "matrix(0.893, -0.45, 0.45, 0.893, 994.005, 212.967)",
    fill: "#3a3768"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.46,
    height: 3.62,
    rx: 0.23,
    transform: "matrix(0.893, -0.45, 0.45, 0.893, 996.185, 217.291)",
    fill: "#3a3768"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.4,
    height: 51.62,
    rx: 2.24,
    transform: "matrix(0.893, -0.45, 0.45, 0.893, 989.468, 203.4)",
    fill: "#3a3768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.4,105.67a.9.9,0,0,0-.4,1.22l.08.17a.91.91,0,0,1-.4,1.23l-9.62,4.84a.9.9,0,0,1-1.22-.4l-.09-.17a.91.91,0,0,0-1.22-.41l-1.87.95a1.72,1.72,0,0,0-.77,2.33L541.33,156a1.75,1.75,0,0,0,2.34.77l16.78-8.45a1.75,1.75,0,0,0,.77-2.34l-20.45-40.59a1.74,1.74,0,0,0-2.34-.77Z",
    transform: "translate(471.36 89.988)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 0.72,
    rx: 0.36,
    transform: "matrix(0.893, -0.45, 0.45, 0.893, 999.323, 200.164)",
    fill: "#e6e8ec"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.41,
    cy: 0.41,
    r: 0.41,
    transform: "translate(1003.07 198.027)",
    fill: "#e6e8ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.8,261.28,544.55,429s21-7,24.25-1.75-3.5-84-3.5-84Z",
    transform: "translate(471.36 89.988)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.05,605.53c-3.25,4.75-24.5,16.25-24.5,16.25s-9,.5-19.5,8.5c-5.43,4.14-24.3,12.35-41.25,19.32-15.83,6.51-30,11.93-30,11.93l-16.32,19S402.8,713.75,402.8,716s-20.769-24.723-20.519-35.973S396.3,666,398.3,665s10-20.75,10-20.75l31.17-20.91,62-41.56,2.86-1.92s8.25,3.78,4.9-27.19c-.65-6-1.74-13.29-3.4-22.17-10.25-54.75,26.5-61,26.5-61l32.25,10.75,7.75,12v.06l1.75,73.94S574.3,600.78,571.05,605.53Z",
    transform: "translate(471.36 89.988)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.55,401.53l-6.25,120s-4.5,176.25,0,187.75,6.25,29.5,6.25,29.5,7.254,28.745,7,31.245,31,15,45-6.5c0,0-12.25-45-12.25-52.53s-1.75-70.5-1.75-70.5,27.25-100,28.5-107,9.75-40.25,9.75-40.25l51.5-1s-1.5-35.75-4.5-43.5-17.75-64.5-17.75-64.5Z",
    transform: "translate(471.36 89.988)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.55,211.78c-2,7-35.75,0-35.75,0l-3.5-5.5s-.35-.7-.94-1.84c-2.16-4.19-7.39-14.11-9.55-15.87-2.75-2.25,29.5-13.25,29.5-13.25l9.88,21.5a39.821,39.821,0,0,1,6.7,5.67C610.39,205.2,612.46,208.59,611.55,211.78Z",
    transform: "translate(471.36 89.988)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.55,215s20,15.78,23,14.64,51.5,31.61,51.5,31.61,5.5,21-17.25,22.25c0,0-48.25-2-50.25-9S555.55,215,555.55,215Z",
    transform: "translate(471.36 89.988)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.05,180.28l-21.75,22.5,30.5,194,12-7s31,13.75,33.5,1,1.81-63,1.81-63L553.05,237s-14.25-31.75-14.25-32.75-20.55-16.5-20.55-16.5l-9.7-7.5Z",
    transform: "translate(471.36 89.988)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.3,181.53l-6,12.25,6,6.33s21.5,43.42,17.25,69.17l4.5,84.75,14.5,14.25L550.05,355l-5.5-77s-14.75-63.5-30.25-83.25l-4.5-17.5Z",
    transform: "translate(471.36 89.988)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.11,113.38a38.33,38.33,0,1,1-7.29-22.49A38.33,38.33,0,0,1,544.11,113.38Z",
    transform: "translate(471.36 89.988)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.55,196.78l-31.5-38s-2.91-1.17,6.92-11.46c0,0,36.1,28.14,38.34,32.92S492.55,196.78,492.55,196.78Z",
    transform: "translate(471.36 89.988)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.3,438.63s-6-3.6-6-7.85-3-64.25-3-64.25-4.4-35.81-9-64.27h0c-2.7-16.77-5.47-31-7.43-33.82l-.08-.12c-5.25-6.75-4.25-39.75-37-88,.44.3,11.73,8.22,20,12.2a27.419,27.419,0,0,0,5.27,2c7.5,1.75,32,11.25,31.25,26.5s1.75,50.25,1.75,50.25V343Z",
    transform: "translate(471.36 89.988)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.3,206.28s10.5,29,9,36.25,24.25,35.75,24.25,35.75l24.5-17-14.5-41.25-5.665-17.772S611.55,209,572.3,206.28Z",
    transform: "translate(471.36 89.988)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.82,90.89l-19,.72a21.16,21.16,0,0,0-5.5.69c-6.79,2.09-9.92,9.31-10.17,15.8s-4,13.76-11.27,14.33a2.81,2.81,0,0,1-2.07-.46,3.42,3.42,0,0,1-.88-1.77,38.7,38.7,0,0,0-4.78-10.68c-3,.54-5.22,3.39-6,6.37s-.57,6.12-.56,9.21a59.608,59.608,0,0,1-1.13,11.69,38.328,38.328,0,1,1,61.393-45.9Z",
    transform: "translate(471.36 89.988)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.33,91.3a21.16,21.16,0,0,1,5.5-.69l23.07-.86c3.38-.13,7.15-.43,9.42-2.94a8.81,8.81,0,0,0,1.76-3.29,14.2,14.2,0,0,0-1.49-11.63c-2.67-4.25-7.35-6.72-11.81-9a137.233,137.233,0,0,0-12.77-6,68,68,0,0,0-50.1.72A20.22,20.22,0,0,0,470.45,60a23.05,23.05,0,0,0-4.86,5.8L458,77.24a15.75,15.75,0,0,0-2.39,4.62c-1.43,5.43,3,10.86,2.54,16.45-.26,2.78-1.73,5.33-2,8.11-.36,3.59,1.28,7,2.89,10.27l13.34,26.91a59.62,59.62,0,0,0,3.23-19.5c0-3.09-.26-6.23.56-9.21s3-5.83,6-6.37a38.569,38.569,0,0,1,4.79,10.68,3.38,3.38,0,0,0,.88,1.77,2.8,2.8,0,0,0,2.07.46c7.31-.57,11-7.77,11.27-14.33S504.54,93.39,511.33,91.3Z",
    transform: "translate(471.36 89.988)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.8,301.53v.73l-.5,83.27s-12.75,70-16.25,72.75-80.25-4.75-80.25-4.75L398.05,219.28c-.25-40,49.75-49.5,59.75-59.25l.32-.45a8.89,8.89,0,0,1,2.52-2.49h0c2.06-1.19,3.37.38,4.12,1.93a11.63,11.63,0,0,1,.78,2.27C506.05,191,529.8,301.53,529.8,301.53Z",
    transform: "translate(471.36 89.988)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.36,171.58l-2.05,8.66s1.5,8.67,10.49,9.42l1.45-4.13S508.55,179.31,508.36,171.58Z",
    transform: "translate(471.36 89.988)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224.535 75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.36,469.89l-4.47,1.28-.18,4.42,134.02,1.73v-1.74Z",
    transform: "translate(409.235 57.268)",
    fill: "#423a59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.89,611.17l-18.58-1.73-6.52-.6V505.5l1.72-23.99.38-5.34h19.17Z",
    transform: "translate(406.235 51.268)",
    fill: "#423a59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.064,522.03s9.606-21.87,13.486-22.5,11,0,11,0l-.63,5.88s-9.5.75-12.5,16.62Z",
    transform: "translate(242.995 1.988)",
    fill: "#423a59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.3,497.41s24.87,12.37,21.62,26.87l-13.5-.75s-6.5-21.62-11.62-22.75S437.3,497.41,437.3,497.41Z",
    transform: "translate(242.995 3.158)",
    fill: "#423a59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.19,477.57l-5.88,131.87-6.52-.6V505.5l1.72-23.99Z",
    transform: "translate(406.235 51.268)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.23,528.5l-4,71.33,136,11.34,5.96-133.6Z",
    transform: "translate(406.235 51.268)",
    fill: "#423a59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.23,536.17l2.66-63,139.3,6.4-6.63,66.6Z",
    transform: "translate(407.385 53.988)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.23,534.17l2.66-63,139.3,6.4-6.63,66.6Z",
    transform: "translate(406.235 51.268)",
    fill: "#423a59"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.75,
    height: 19.5,
    transform: "translate(656.045 591.518)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M412.55,455.78l-2.5,5.628s-5.25,30.849,1.25,34.6,25.75,3.96,26.75,2.084,8-23.136,8-23.136l2-16.583Z",
    transform: "translate(471.36 89.988)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.05,426.78v35.75s26.5,5,38-3.64c0,0-10.75-34.61-6.75-43.36S410.05,426.78,410.05,426.78Z",
    transform: "translate(471.36 89.988)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.05,215.53l-7,3.75s-1.25,15-2,17,0,22.25,0,22.25l-.34,41s-1.08,21.75,0,29.5S398,366.28,398,366.28s6.76,28.75,4.26,39,.25,33.25,4.5,31.25,43.5-9.75,45.5-11.25,1-15.5,0-17.25-7-25.5-6.5-31-1.75-53.75-1.75-53.75,3.75-51.5,5.25-63.5-3-47.25-7-47.75S426.55,184.28,405.05,215.53Z",
    transform: "translate(471.36 89.988)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,405.11s11.72-6.66,14.41-5.33S408,405.11,408,405.11Z",
    transform: "translate(471.36 89.988)",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkingOnPhone);
export default __webpack_public_path__ + "static/media/talking_on_phone.d0ea5bcb69e62bfdaf9fd0e36e9a5fac.svg";
export { ForwardRef as ReactComponent };